import React from 'react';
import { BaseAPIModel } from '@weezevent/weezjs-core';
import { spamScoreColor } from '../constants/moderation';
import { Trans } from 'react-i18next';

export default class LogSpamEventModerationHistory extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ attendeeId, organizationId }) {
        if (!attendeeId) {
            throw new Error('[LogSpamEventModerationHistory] attendeeId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/attendees/${attendeeId}/event_spam_moderation_logs`;
    }

    get name() {
        return <Trans i18nKey={'ticket.moderation.attendee.history.spam_validation'} />;
    }

    get status() {
        return this.object.status_name || '';
    }

    get color() {
        return spamScoreColor(this.object.score);
    }

    get isSpamLog() {
        return true;
    }
}
